export const COLORS = {
    btnBg: '#e8e1d7',
    color: ' #09090b',
    colorBrown: "#371300",
    btnBrownBg: '#d39b4e'
}